import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import { Badge, Menu, Popover } from 'antd';

import ls from 'local-storage';
import styled from 'styled-components';

import { useActivePackages } from '@hooks/API/Packages/UsePackages';

import AddPackageDrawer from '@components/ActivePackages/AddPackageDrawer';
import NwIcon from '@components/Gui/NwIcon';
import PackageDrawer from '@components/PackageDrawer/PackageDrawer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    .packages-icon-holder {
        position: relative;
        font-size: 2rem;
        cursor: pointer;

        &.disabled {
            cursor: not-allowed;
            opacity: 0.4;
        }

        .packages-badge {
            position: absolute;
            top: 8px;
            right: 0;
            background: ${(props) => props.theme.PrimaryColor};
            color: white;
            font-size: 0.6rem;
            width: 1rem;
            height: 1rem;
            text-align: center;
            font-weight: bold;
            vertical-align: middle;
            border-radius: 50%;
            line-height: 1.5em;
            font-family: 'Chivo Mono', monospace;
        }
    }
`;

const HeaderPackagesButton = () => {
    const navigate = useNavigate();
    const [isAddNewPackage, setIsAddNewPackage] = useState(false);
    const { data: packages } = useActivePackages();
    const latestPackageId = ls.get('nw_config_latest_package');
    const [isPackageDrawer, setIsPackageDrawer] = useState(false);
    const [packageId, setPackageId] = useState();
    const [open, setOpen] = useState(false);

    const onClick = (e) => {
        const action = e.key.split('-')[0];
        let param = '';
        if (e.key.split('-').length > 1) {
            param = e.key.split('-')[1];
        }
        switch (action) {
            case 'new':
                createNewPackage();
                break;
            case 'pack':
                setPackageId(parseInt(param));
                setIsPackageDrawer(true);
                break;
            case 'sentPackages':
                navigate('/packages');
                break;
            case 'activePackages':
                navigate('/packages/active');
                break;
            default:
                break;
        }
        setOpen(false);
    };

    const handleClosePackageDrawer = () => {
        setIsPackageDrawer(false);
        setPackageId();
    };

    const createNewPackage = () => {
        setIsAddNewPackage(true);
    };

    const handleOpenPackage = (packId) => {
        setPackageId(packId);
        setIsPackageDrawer(true);
    };

    const latestPackage = packages ? packages.find((pack) => pack.ID === latestPackageId) : null;
    const items = [];
    if (latestPackage) {
        items.push({
            type: 'group',
            label: <span className="submenu-title-wrapper">Last Used</span>,
            children: [
                {
                    key: `pack-${latestPackage.ID}`,
                    className: 'small',
                    label: (
                        <>
                            {latestPackage.Name} <Badge count={latestPackage.Models.length} />
                        </>
                    ),
                },
            ],
        });
    }
    items.push({
        type: 'group',
        label: <span className="submenu-title-wrapper">Active Packages</span>,
        children:
            packages && packages.length > 0
                ? packages
                      .filter((p) => p.ID !== latestPackageId)
                      .map((p) => {
                          return {
                              key: `pack-${p.ID}`,
                              label: (
                                  <>
                                      {p.Name} <Badge count={p.Models.length} />
                                  </>
                              ),
                          };
                      })
                : [],
    });
    items.push({
        type: 'group',
        label: <span className="submenu-title-wrapper">Actions</span>,
        children: [
            {
                key: 'new',
                className: 'small',
                label: (
                    <>
                        <NwIcon icon={byPrefixAndName.fasl['plus']} /> Create new package
                    </>
                ),
            },
            {
                key: 'activePackages',
                className: 'small',
                label: (
                    <>
                        <NwIcon icon={byPrefixAndName.fasl['hand-pointer']} /> Active Packages
                    </>
                ),
            },
        ],
    });
    items.push({
        key: 'sentPackages',
        label: (
            <>
                <NwIcon icon={byPrefixAndName.fasl['paper-plane']} /> Sent packages
            </>
        ),
        className: 'small',
    });

    const menuContent = (
        <Menu onClick={onClick} mode="vertical" selectable={false} className="packages-menu-popover" items={items} />
    );

    return (
        <Wrapper>
            {packages ? (
                <>
                    <Popover
                        content={menuContent}
                        trigger="click"
                        placement="bottom"
                        overlayClassName="main-nav-submenu"
                        open={open}
                        onOpenChange={setOpen}
                    >
                        <div className="packages-icon-holder">
                            <NwIcon icon={byPrefixAndName.fasl['book-arrow-right']} />
                            {packages.length > 0 && <span className="packages-badge">{packages.length}</span>}
                        </div>
                    </Popover>
                    {isAddNewPackage && (
                        <AddPackageDrawer
                            onAddedPackage={handleOpenPackage}
                            onClose={() => setIsAddNewPackage(false)}
                        />
                    )}
                </>
            ) : (
                <div className="packages-icon-holder disabled">
                    <NwIcon icon={byPrefixAndName.fasl['book-arrow-right']} disabled />
                </div>
            )}
            {isPackageDrawer && <PackageDrawer packageId={packageId} onClose={handleClosePackageDrawer} />}
        </Wrapper>
    );
};

export default HeaderPackagesButton;
